import {EffectPointerPlayer} from "../../../../Server/DB/@Shared/EffectPointerPlayer.js";
import {AlarmSequence} from "../../../../Server/DB/engineConfigs/@EngineConfig/Alarms/@AlarmConfig.js";
import {EngineConfig_LightAlarm} from "../../../../Server/DB/engineConfigs/@EngineConfig/Alarms/@EC_BasicAlarms.js";
import {ClearScreenLight} from "../../../../Store/main/engine/lights.js";
import {ResetLight_Kasa} from "../../../../Utils/Bridge/Bridge_Native/Kasa.js";
import {LiveSession} from "../../../LiveSession.js";
import {AlarmComp} from "./@AlarmComp.js";

export class LightAlarmComp extends AlarmComp<EngineConfig_LightAlarm> {
	constructor(session: LiveSession, sequence: AlarmSequence, config: EngineConfig_LightAlarm) {
		super(session, sequence, config);
	}

	promptPlayer = new EffectPointerPlayer();

	override OnStart() {
		this.promptPlayer.effectPointer = this.c.effectPointer;
		this.promptPlayer.OnStart();
	}
	override OnStop() {
		// in addition to the regular LightPlayer.Stop() behavior (through this.StopAlarm()), we also want to...
		// ...*ensure* lifx lights stopped
		//ResetLight_LIFX(); // commented; can cause fetch error
		// ...*ensure* kasa lights stopped
		ResetLight_Kasa();
		// ...*ensure* screen-light cleared
		ClearScreenLight();
		return super.OnStop();
	}

	override async PlayAlarmEffect() {
		if (this.s.coreData.alarms_tillAlarmEnd_blockLightEffects) return;
		await this.promptPlayer.Play(this.intensity);
	}
	override UpdatePrompt_ForReducedIntensity() {
		this.promptPlayer.NotifyReducedIntensity(this.intensity);
	}
	override StopAlarm(...args: Parameters<AlarmComp<any>["StopAlarm"]>) {
		this.promptPlayer.Stop();
		return super.StopAlarm(...args);
	}
}